<template>
  <van-dialog
    v-model="dialogVisible"
    :show-confirm-button="false"
    width="250px"
    :close-on-click-overlay="true"
    class="find-account-dialog"
  >
    <div class="find-account-container">
      <h1>如何查看账号？</h1>
      <img @click="dialogVisible = false" class="close" src="@/assets/images/close-voucher.png" alt="" />
      <div>
        1.在APP内下载游戏并重新注册账号。<br />2.点击悬浮窗查看账号，如下图：
      </div>
      <img class="content-img" :src="contentImg" alt="">
    </div>
  </van-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    platName: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
    contentImg() {
        let obj = {
            '果盘': 'http://wmsy666.com/wanmengapp/image/icon_guopan.png',
            '当乐': 'http://wmsy666.com/wanmengapp/image/icon_dangle.png',
            '3011': 'http://wmsy666.com/wanmengapp/image/icon_3011.png',
            '天宇': 'http://wmsy666.com/wanmengapp/image/icon_tianyu.png',
            '91玩': 'http://wmsy666.com/wanmengapp/image/icon_91wan.png',
            '爱趣': 'http://wmsy666.com/wanmengapp/image/icon_aiqu.png',
            '98sy': 'http://wmsy666.com/wanmengapp/image/icon_98sy.png',
        }
        return obj[this.platName]
    }
  },
  mounted() {},
  methods: {
    confirm() {
      this.dialogVisible = false;
      if (this.noticeInfo.jump == 1) {
        this.$router.push({ path: "/gameCircle" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.find-account-dialog,
.van-dialog__content {
  overflow: visible; /* 允许内容超出 */
}
.find-account-container {
  width: 500px;

  padding: 40px 50px;
  text-align: center;

  h1 {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 30px;
    color: #22242a;
    line-height: 42px;
    margin-bottom: 22px;
  }
  .close {
    position: absolute;
    right: 30px;
    top: 30px;
    width: 36px;
    height: 36px;
  }
  div {
    text-align: left;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #22242a;
    line-height: 33px;
  }
  .content-img {
    width: 400px;
    height: 420px;
    margin-top: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FindAccountDialog.vue